module.exports = __webpack_public_path__ + "f9afbcd1a509b304307e6fbb7f60a632.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-31.png
// module id = 2263
// module chunks = 0